export const ENGLISH = "en";
export const SPANISH = "es";
export const SID_LOOKUP = "sid";
export const PRODUCTION = "production";
export const CLOUDINARY_LIB_URL =
    "https://upload-widget.cloudinary.com/global/all.js";
